const thanks3 = (data) => {
  const color = data.color;

  return {
    id: "cGLNkCYKsj",
    elements: [
      {
        type: "shape",
        id: "CovtKzQNjZ",
        width: 961.1668307086615,
        height: 256.76550196850394,
        left: 0,
        top: 142.83899278215222,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "8Iq_mU02xh",
        width: 292.7788713910761,
        height: 86.67191601049869,
        left: 439.14673556430444,
        top: 189.0914534120735,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><strong><span style="font-size: 57.8125px;"><span style="font-family: Microsoft Yahei;"><span style="color: #ffffff;">THANKS</span></span></span></strong></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "87EeElVigY",
        width: 274.3228346456693,
        height: 28.005905511811022,
        left: 439.14673556430444,
        top: 306.347687007874,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="font-size: 12.5px;"><span style="font-family: Microsoft Yahei;"><span style="color: #ffffff;">感谢观看</span></span></span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "AgM7iU_jNc",
        width: 295.05003280839895,
        height: 295.05003280839895,
        left: 94.69996719160105,
        top: 123.69996719160105,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        opacity: 1,
        shadow: { h: 3, v: 3, blur: 2, color: "#808080" },
      },
      {
        type: "shape",
        id: "IXDlfIZa4R",
        width: 81.83997703412074,
        height: 31.26000656167979,
        left: 203.39000984251967,
        top: 242.2399934383202,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Y4ZsUSUMuB",
        width: 145.5100065616798,
        height: 110.33431916697396,
        left: 171.46998031496062,
        top: 214.91002296587925,
        viewBox: [1024, 1024],
        path: "M985.31555555 88.74666667H38.68444445c-20.13866667 0-36.40888889 16.27022222-36.4088889 36.40888888v564.33777778c0 20.13866667 16.27022222 36.40888889 36.4088889 36.40888889h432.35555555v127.43111111H275.34222222c-10.01244445 0-18.20444445 8.192-18.20444444 18.20444445v54.61333333c0 5.00622222 4.096 9.10222222 9.10222222 9.10222222h491.52c5.00622222 0 9.10222222-4.096 9.10222222-9.10222222v-54.61333333c0-10.01244445-8.192-18.20444445-18.20444444-18.20444445H552.96V725.90222222h432.35555555c20.13866667 0 36.40888889-16.27022222 36.4088889-36.40888889V125.15555555c0-20.13866667-16.27022222-36.40888889-36.4088889-36.40888888z m-45.5111111 555.23555555H84.19555555V170.66666667h855.6088889v473.31555555z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        special: true,
      },
      {
        type: "line",
        id: "ht-yhkDy1F",
        width: 0.5,
        left: 454.380249343832,
        top: 292.62516404199476,
        start: [0, 0],
        end: [268.68282480314963, 0],
        style: "solid",
        color: "#EFFFFD",
        points: ["", ""],
      },
    ],
    background: { type: "solid", color: "#FFFFFF" },
  };
};

export default thanks3;
